app.controller('previewExercisePerformCtrl', [
    '$scope', '$rootScope', '$http', '$mdDialog', '$state', '$stateParams', '$timeout', '$log', function ($scope, $rootScope, $http, $mdDialog, $state, $stateParams, $timeout, $log) {
        var vm = this;

        console.log("previewExercisePerformCtrl...");

        $scope.$on('$viewContentLoaded', function () {
            $timeout(function() {
                if (window.MathJax != null) {
                    $log.debug("previewExercisePerformCtrl: viewContentLoaded typeset");
                    window.MathJax.Hub.Queue(
                        ["Typeset",MathJax.Hub],
                        [function() { $scope.$apply(function() {
                            vm.showMathLoader = false;
                        }); }]
                    );
                } else {
                    $log.debug("previewExercisePerformCtrl: no window.MathJax, skipping typeset");
                }
            }, 1);
        });

        vm.setupExercise = function(exercise, questionIndex, fullFlow) {
            // Copied from gameService.js.
            function indexify(collection, forEachFunc) {
                for (var i = 0; i < collection.length; i++) {
                    var item = collection[i];
                    item.index = i;
                    if (forEachFunc) {
                        forEachFunc(item);
                    }
                }
            }

            indexify(exercise.questions, function(question) {
                indexify(question.answers);
            });

            vm.exercise = exercise;
            vm.questionIndex = questionIndex;
            vm.question = exercise.questions[questionIndex];
            vm.fullFlow = fullFlow;
        }

        vm.initialize = function() {
            if (!vm.fullFlow) {
                vm.progressIndex = 0;
                vm.progressCount = 1;
                vm.progressArray = new Array(vm.progressCount);
            } else {
                vm.progressIndex = 1 + vm.questionIndex;
                vm.progressCount = 1 + vm.exercise.questions.length + 1 + vm.exercise.evaluationQuestions.length + 1;
                vm.progressArray = new Array(vm.progressCount);
            }

            vm.points = 40;

            vm.activeAnswers = [ true, true, true, true ];
            vm.done = false;

            vm.popupShown = false;
            vm.answer = null;
            vm.answerIndex = 0;

            vm.helpAvailable = vm.question.extraButtonText.length > 0;

            vm.firstRun = true;
            vm.helpShown = vm.helpAvailable;
            vm.showMathLoader = vm.helpAvailable;
        }

        var exerciseJson = window.localStorage.getItem("simulatorExercise");
        var exercise = JSON.parse(exerciseJson);
        var questionIndexStr = window.localStorage.getItem("simulatorExerciseQuestionIndex");
        var questionIndex = parseInt(questionIndexStr, 10);
        var fullFlow = window.localStorage.getItem("simulatorFullFlow") == "true";
        vm.setupExercise(exercise, questionIndex, fullFlow);
        vm.initialize();

        var parent = angular.element("#performarrow")[0];
        vm.arrow = new TivoliArrow(parent);
        vm.arrow.start();

        $scope.$on('$destroy', function() {
            vm.arrow.stop();
        	vm.arrow = null;
        });

        vm.popupShown = false;
        vm.answer = null;
        vm.answerIndex = 0;

        vm.helpAvailable = vm.question.extraButtonText.length > 0;

        vm.showMathLoader = vm.helpAvailable;

    	vm.performAnswer = function(idx) {
    		var answerObj = vm.question.answers[idx];

            // Don't do anything if the answer isn't active.
            if (!vm.activeAnswers[idx]) {
                return;
            }

            if (vm.question.answers[idx].correct) {
                var numTries = vm.activeAnswers.reduce(function(acc, val) {
                    if (val == false) {
                        acc += 1;
                    }
                    return acc;
                }, 0);

                vm.activeAnswers = [ false, false, false, false ];
                vm.done = true;
                return;
			}

            vm.answerIndex = idx;
            vm.answer = answerObj;
           	vm.popupShown = true;
    	}

    	vm.hidePopup = function() {
    		var idx = vm.answerIndex;

			vm.activeAnswers[idx] = false;
            vm.points -= 10;
            vm.popupShown = false;
    	}

        vm.firstRun = true;
        vm.helpShown = vm.helpAvailable;
        vm.showHelp = function() {
        	vm.helpShown = true;
            vm.firstRun = false;
        }

        vm.hideHelp = function() {
        	vm.helpShown = false;
            vm.firstRun = false

            $timeout(function() {
                var elements = angular.element(".helpinner");
                if (elements.length > 0) {
                    elements[0].scrollTo(0, 0);
                }
            }, 0); // XXX: must match the transition time for .helppopover.
        }

        vm.next = function() {
            if (!vm.done) {
                return;
            }

            console.log("previewExercisePerformCtrl... NEXT???");

    		// Go to question?
    		if (vm.questionIndex < vm.exercise.questions.length - 1) {
    			var questionIndex = vm.questionIndex + 1;
    			window.localStorage.setItem("simulatorExerciseQuestionIndex", "" + questionIndex);

                $state.go('preview.exerciseperform', {}, {reload: "preview.exerciseperform"});
			// Go to evaluation interstitial?
    		} else if (vm.questionIndex === vm.exercise.questions.length - 1) {
    			$state.go('preview.exerciseevalbegin', {});
    		}
    	}
    }
]);